import React from "react";
import "./stylesheets/skills.css";
import s1 from "../assets/skills 1.webp";
import s2 from "../assets/skills1.webp";
import s3 from "../assets/s3.webp";
import s4 from "../assets/s4.webp";

const Skills = () => {
	return (
		<div id="skills">
			<h1>
				My <span style={{ color: "#dc143c" }}>Technical</span> Skills
			</h1>

			<div style={{position:"relative",zIndex:"-1"}}>
				<div data-aos="zoom-in">
					<img src={s1} alt="" />
				</div>
				<div data-aos="zoom-in">
					<img style={{marginTop:"2px"}} src={s2} alt="" />
				</div>
				<div data-aos="zoom-in">
					<img src={s3} alt="" />
				</div>
				<div data-aos="zoom-in">
					<img src={s4} alt="" />
				</div>
			</div>
		</div>
	);
};

export default Skills;
